import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/apiConfig';
import {
  RetentionCleanupResult,
  RetentionPoliciesDto,
  RetentionPoliciesUpdateDto,
} from '../types/RetentionSettings';

export const getRetentionPolicies = async (): Promise<RetentionPoliciesDto> => {
  const response = await apiClient.get<RetentionPoliciesDto>(API_ENDPOINTS.SETTINGS.RETENTION);
  return response.data;
};

export const updateRetentionPolicies = async (
  request: RetentionPoliciesUpdateDto
): Promise<RetentionPoliciesDto> => {
  const response = await apiClient.put<RetentionPoliciesDto>(API_ENDPOINTS.SETTINGS.RETENTION, request);
  return response.data;
};

export const runRetentionCleanup = async (): Promise<RetentionCleanupResult> => {
  const response = await apiClient.post<RetentionCleanupResult>(API_ENDPOINTS.SETTINGS.RETENTION_RUN);
  return response.data;
};
